<template>
  <div>
    <ProgressBar :visible="isLoading" :theme="true" />
    <v-dialog v-model="isQrcodeDialog" max-width="460">
      <v-card>
        <v-card-title class="headline text-xs-center">
          {{ $t("Scan QR code to download the app") }}
        </v-card-title>
        <div class="qr--image">
          <img :src="require('../assets/qr-mobile.svg')" alt="qr-image" width="350" />
        </div>
      </v-card>
    </v-dialog>

    <div id="login">
      <v-content>
        <div v-if="!isRanOnLocal && !isLocationEnabled" class="location-disabled-msg">
          <b>IMPORTANT! </b>{{ locationDisplayMsg }}
        </div>
        <div id="overlay" v-show="!isRanOnLocal && !isLocationEnabled" />
        <div class="bg-img">
          <img src="./../assets/login/solar.jpg" alt="" />
        </div>
        <div class="enerman">
          <v-container text-xs-center>
            <v-layout row wrap>
              <v-flex xs12 class="pad-0">
                <v-layout row wrap class="login-box-6">
                  <v-flex
                    flex
                    xs12
                    sm12
                    md5
                    lg5
                    xl5
                    class="bg-img col-pad-0 align-self-center"
                  >
                    <v-tooltip bottom class="view-more">
                      <template slot="activator">
                        <a href="https://www.enerman.in" target="_blank">
                          <div class="avi-logo">
                            <img
                              class="img"
                              src="./../assets/logo/enerman-etisol_new_dark.svg"
                              alt=""
                              width="150px"
                              height="150px"
                            />
                          </div>
                        </a>
                      </template>
                      <span>enerman.in</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex flex xs12 sm12 md7 lg7 xl7 class="col-pad-0 align-self-center">
                    <div class="login-inner-form" v-if="activeLoginScreen == 'login'">
                      <div class="details">
                        <h3 class="login-heading">
                          {{ $t("Please login to your account") }}
                        </h3>
                        <v-form ref="form">
                          <v-text-field
                            class="unq__caret"
                            light
                            append-icon="person"
                            :label="$t('E-mail')"
                            type="email"
                            :rules="[computedEmailRule, computedEmailRule2]"
                            v-model="model.username"
                            :placeholder="$t('E-mail')"
                            required
                          ></v-text-field>
                          <v-text-field
                            class="unq__caret"
                            light
                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                            name="password"
                            :label="$t('Password')"
                            :placeholder="$t('Password')"
                            id="password"
                            :type="showPassword ? 'text' : 'password'"
                            :rules="[computedPasswordRule]"
                            v-model="model.password"
                            required
                            @keydown.enter="getLoginOtpHandler"
                            @click:append="showPassword = !showPassword"
                          >
                          </v-text-field>
                        </v-form>

                        <v-btn
                          class="btn-md btn-theme btn-block"
                          color="#0E3F6D"
                          @click.prevent="getLoginOtpHandler"
                          :disabled="
                            (!isRanOnLocal && !isLocationEnabled) || isLoginDisabled
                          "
                        >
                          {{ $t("Login") }}
                        </v-btn>
                        <div class="space">
                          <a @click="handleMobileApp" class="link-text">
                            {{ $t("Get Mobile App") }}
                          </a>
                        </div>
                        <div class="forgot-password-link">
                          <a @click="SET_ACTIVE_LOGIN_SCREEN('reset')" class="link-text">
                            {{ `${$t("Forgot Password")}?` }}
                          </a>
                        </div>
                        <div class="space">
                          <select
                            v-model="selectedLanguage"
                            @change="languageChangeHandler"
                          >
                            <option
                              v-for="(item, index) in Languages"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="login-inner-form" v-if="activeLoginScreen == 'reset'">
                      <div class="details">
                        <h3 class="login-heading">{{ $t("Forgot Password?") }}</h3>
                        <v-text-field
                          class="unq__caret"
                          light
                          append-icon="email"
                          :placeholder="$t('E-mail')"
                          v-model="model.username"
                          :label="$t('E-mail')"
                          type="text"
                          :rules="[computedEmailRule, computedEmailRule2]"
                        >
                        </v-text-field>
                        <p v-show="getGeneralState('mailResendTime') > 0">
                          {{ $t("Resend email after 10 mins", { min: timeRemaining }) }}
                        </p>
                        <v-btn
                          class="btn-md btn-theme btn-block"
                          color="#0E3F6D"
                          :disabled="!isLocationEnabled || !isResendEmail"
                          @click.prevent="sendResetOtpHandler"
                        >
                          {{ $t("Get Mail") }}
                        </v-btn>
                        <v-card-actions class="justify-center">
                          <div class="space">
                            <a
                              @click="SET_ACTIVE_LOGIN_SCREEN('login')"
                              class="link-text"
                            >
                              {{ $t("Back to Login") }}
                            </a>
                          </div>
                        </v-card-actions>
                      </div>
                    </div>
                    <div
                      class="login-inner-form"
                      v-if="
                        activeLoginScreen == 'loginOtp' || activeLoginScreen == 'resetOtp'
                      "
                    >
                      <div class="details">
                        <h3 class="login-heading">
                          {{ $t("Enter the OTP sent to your email") }}
                        </h3>
                        <OtpInputBox @otpTracker="(val) => (otpText = val)" />
                        <!-- <p v-show="getGeneralState('mailResendTime') > 0">
                          {{ $t('Resend email after 10 mins', { min: timeRemaining }) }}
                        </p> -->
                        <v-btn
                          class="btn-md btn-theme btn-block"
                          color="#0E3F6D"
                          :disabled="!isLocationEnabled"
                          @click.prevent="verifyOtpHandler"
                        >
                          {{ $t("Verify OTP") }}
                        </v-btn>
                        <v-card-actions class="justify-center">
                          <div class="space">
                            <a
                              @click="SET_ACTIVE_LOGIN_SCREEN('login')"
                              class="link-text"
                            >
                              {{ $t("Back to Login") }}
                            </a>
                          </div>
                        </v-card-actions>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-content>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import i18n from "@/plugins/i18n";
import { getClientSideInfo } from "@/util/mixin/index.js";
import CustomSelect from "@/components/common/CustomSelect";
import OtpInputBox from "@/components/common/OtpInputBox";
import ProgressBar from "@/components/utility/ProgressBar.vue";

export default {
  mixins: [getClientSideInfo],
  components: {
    CustomSelect,
    ProgressBar,
    OtpInputBox,
  },
  data: () => ({
    showPassword: false,
    isQrcodeDialog: false,
    model: {
      username: "",
      password: "",
    },
    otpText: "",
    isLoading: false,
    isLoginDisabled: false,
    timeRemaining: null,
    interval: null,
    Languages: [
      {
        text: "English",
        value: "en",
      },
      {
        text: "Français",
        value: "fr",
      },
    ],
    selectedLanguage: "en",
  }),
  computed: {
    ...mapGetters(["hasPlantAssigned", "getGeneralState", "getRules", "getUserInfo"]),
    activeLoginScreen() {
      return this.getGeneralState("activeLoginScreen");
    },
    isResendEmail() {
      if (
        this.getGeneralState("mailResendTime") == null ||
        this.getGeneralState("mailResendTime") <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    computedEmailRule() {
      if (!!this.model.username) {
        return true;
      } else {
        return this.$t("E-mail is required");
      }
    },
    computedEmailRule2() {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRegex.test(this.model.username)) {
        return this.$t("E-mail must be valid");
      }

      const atIndex = this.model.username.indexOf("@");
      if (atIndex !== -1) {
        const usernamePart = this.model.username.substring(0, atIndex);
        if (usernamePart.length > 64) {
          return "Email username cannot exceed 64 characters.";
        }
      }
      return true;
    },
    computedPasswordRule() {
      if (!this.model.password) {
        return this.$t("Password is required");
      }

      if (this.model.password.length > 16) {
        return "Password cannot exceed 16 characters.";
      }
      return true;
    },
  },
  mounted() {
    if (this.hasPlantAssigned && this.getGeneralState("isPasswordUpdateSkip")) {
      this.$router.push({
        name: "home",
      });
    }

    // This will be going even if you refresh the page
    if (!this.isResendEmail) {
      this.resendTimeRemaining();
    }

    this.selectedLanguage = this.getGeneralState("language");
    i18n.locale = this.selectedLanguage;
  },
  methods: {
    ...mapActions([
      "sendResetOtpAction",
      "loginWithOtpAction",
      "verifyResetOtpAction",
      "fetchLoginOtpAction",
    ]),
    ...mapMutations([
      "SET_MAIL_RESEND_TIME",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_LANGUAGE",
      "SET_ACTIVE_LOGIN_SCREEN",
    ]),
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true);
      this.SET_SNACKBAR_CONTENT(payload);
    },
    resendTimeRemaining() {
      this.interval = setInterval(() => {
        this.SET_MAIL_RESEND_TIME(this.getGeneralState("mailResendTime") - 1);
        let mins = Math.floor(this.getGeneralState("mailResendTime") / 60);
        let seconds = this.getGeneralState("mailResendTime") % 60;
        this.timeRemaining = `${mins}:${seconds}`;
        if (this.getGeneralState("mailResendTime") <= 0) {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    async sendResetOtpHandler() {
      if (this.isResendEmail) {
        if (this.model.username === "") {
          this.updateSnackbar({
            icon: "error",
            timeout: 5000,
            header: "",
            message: "Please enter a valid Email",
          });
          return;
        }
        try {
          await this.sendResetOtpAction(this.model.username);
          this.resendTimeRemaining();
        } catch (err) {
          console.error(err, "ERROR");
        }
      }
    },
    async verifyLoginOtpHandler() {
      const userId = this.getUserInfo("userId");
      const payload = {
        userId,
        code: this.otpText,
        info: await this.clientsInfo(),
      };
      try {
        await this.loginWithOtpAction(payload);
        const diff = this.getGeneralState("passwordResetDiff");
        if (diff < 85) {
          if (this.getGeneralState("showHomeDB")) {
            this.$router.push(
              `${this.getRules(["rule", "access_config", "home", "path"])}`
            );
          } else {
            this.$router.push(
              `${this.getRules(["rule", "access_config", "plantOverview", "path"])}`
            );
          }
        } else {
          this.$router.push({
            name: "setPassword",
          });
        }
      } catch (err) {
        if (err.response && err.response.status === 409) {
          const loggedInSessions = err.response.data.data;
          const jsonString = JSON.stringify({
            data: loggedInSessions,
            email: this.model.username,
            password: this.model.password,
          });

          // Convert JSON string to Base64
          const info = Buffer.from(jsonString).toString("base64");
          this.$router.push({
            name: "sessionManagement",
            params: {
              info: info,
              otp: this.otpText,
            },
          });
        } else {
          this.updateSnackbar({
            icon: "error",
            timeout: 5000,
            header: "",
            message: err.response.data.message || "OTP verification failed",
          });
        }
      }
    },
    async verifyResetOtpHandler() {
      try {
        await this.verifyResetOtpAction({
          code: this.otpText,
          email: this.model.username,
        });

        this.$router.push({
          name: "setPassword",
        });
      } catch (err) {
        console.error(err, "ERROR");
      }
    },
    async verifyOtpHandler() {
      if (this.activeLoginScreen == "loginOtp") {
        await this.verifyLoginOtpHandler();
      } else if (this.activeLoginScreen == "resetOtp") {
        this.verifyResetOtpHandler();
      }
    },
    async getLoginOtpHandler() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          this.isLoginDisabled = true;

          const recaptchaToken = await new Promise((resolve) => {
            grecaptcha.enterprise.ready(async () => {
              const token = await grecaptcha.enterprise.execute(
                process.env.VUE_APP_RECAPTCHA_KEY,
                { action: "login" }
              );
              resolve(token);
            });
          });

          const payload = {
            email: this.model.username,
            password: this.model.password,
            info: await this.clientsInfo(),
            recaptchaToken,
          };
          await this.fetchLoginOtpAction(payload);
          this.isLoading = false;
          this.isLoginDisabled = false;
        } catch (err) {
          this.isLoading = false;
          this.isLoginDisabled = false;
        }
      } else {
        if (this.model.username.includes("@")) {
          const usernamePart = this.model.username.substring(
            0,
            this.model.username.indexOf("@")
          );
          if (usernamePart.length > 64) {
            this.updateSnackbar({
              icon: "error",
              header: "",
              message: "Email username cannot exceed 64 characters.",
            });
            return;
          }
        }
        if (this.model.password.length > 16) {
          this.updateSnackbar({
            icon: "error",
            header: "",
            message: "Password cannot exceed 16 characters.",
          });
          return;
        }
        this.updateSnackbar({
          icon: "error",
          header: "",
          message: "Please enter valid email and password.",
        });
        this.model.username = "";
        this.isProgress = false;
      }
    },
    languageChangeHandler(event) {
      i18n.locale = event.target.value;
      this.SET_LANGUAGE(event.target.value);
    },
    handleMobileApp() {
      if (window.innerWidth < 600) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.pyramid.enerman";
      } else {
        this.isQrcodeDialog = true;
      }
    },
  },
};
</script>

<style scoped>
.bg-img {
  position: fixed;
  height: 100%;
  width: 100%;
}

.bg-img > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-attachment: fixed;
  /* opacity: 0.65; */
  overflow: hidden;
}

.enerman {
  background: transparent;
}

.avi-logo {
  margin-bottom: 0px;
}

.space {
  padding-bottom: 10px;
}

.login-heading {
  font-size: 1.375rem;
}

.enerman {
  min-width: 100%;
  min-height: 100vh;
  position: relative;
  text-align: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}

.enerman .login-inner-form {
  color: #717171;
  text-align: center;
}

.enerman .col-pad-0 {
  padding: 0;
}

.login-box-6 {
  margin: 0 150px 0 200px;
  max-width: 700px;
  border-radius: 10px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.flex-gap {
  gap: 12px;
}

.enerman .login-inner-form .details p a {
  margin-left: 3px;
  color: #717171;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.enerman .login-inner-form .details p {
  margin-bottom: 0;
  font-size: 14px;
}

.enerman .login-inner-form .details {
  padding: 30px 60px 30px 0;
}

.enerman .bg-img {
  position: relative;
  background-size: cover;
  width: 100%;
  bottom: 0;
  border-radius: 10px;
  padding: 80px 30px;
  background-color: var(--v-primary-base);
  margin: 30px 0;
  left: -60px;
}

.enerman .login-inner-form h3 {
  margin: 0 0 25px;
  font-size: 22px;
  font-weight: 400;
  color: #0e3f6d;
}

.enerman .login-inner-form .form-group {
  margin-bottom: 20px;
}

.enerman .login-inner-form .input-text {
  outline: none;
  width: 100%;
  padding: 10px 20px;
  font-size: 15px;
  outline: 0;
  font-weight: 500;
  color: #717171;
  border-radius: 3px;
  border: 1px solid #dbdbdb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
}

.btn-md {
  cursor: pointer;
  padding: 10px 50px 8px 50px;
  letter-spacing: 1px;
  font-size: 15px;
  font-weight: 400;
  height: 45px;
  border-radius: 3px;
  text-transform: uppercase;
  width: 70%;
}

.btn-secondary {
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  height: 20px;
  border-radius: 3px;
  text-transform: uppercase;
}

.enerman .bg-img .logo {
  height: 30px;
  margin-bottom: 20px;
}

.enerman .bg-img p {
  font-size: 15px;
  color: #e8e8e8;
  margin-bottom: 30px;
}

.enerman .login-inner-form input[type="checkbox"],
input[type="radio"] {
  margin-right: 3px;
}

.enerman .login-inner-form button:focus {
  outline: none;
  outline: 0 auto -webkit-focus-ring-color;
}

.enerman .login-inner-form .btn-theme.focus,
.btn-theme:focus {
  box-shadow: none;
}

.enerman .login-inner-form .btn-theme {
  background: var(--v-primary-base) !important;
  border: none;
  color: #fff;
}

.enerman .login-inner-form .btn-theme:hover {
  background: #194c7d;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}

@media (min-width: 1200px) {
  .login-box-6 {
    margin: 0 auto;
  }
}

@media (max-width: 1200px) {
  .login-box-6 {
    margin: 0 70px 0 120px;
  }
}

@media (max-width: 960px) {
  .enerman .bg-img {
    position: relative;
    background-size: cover;
    width: 100%;
    bottom: 0;
    border-radius: 10px;
    padding: 0px 0px;
    margin: -25px 25px;
    left: 0px;
  }
}

@media (max-width: 600px) {
  .v-content {
    padding: 0px 0px 0px !important;
  }

  .enerman .bg-img {
    position: relative;
    background-size: cover;
    width: 100%;
    bottom: 0;
    border-radius: 10px;
    padding: 0px 0px;
    margin: -25px 25px;
    left: 0px;
  }
}

@media (max-width: 992px) {
  .none-992 {
    display: none;
  }

  .login-box-6 {
    margin: 0 auto;
  }

  .enerman .login-inner-form .details {
    padding: 30px;
  }

  .enerman .pad-0 {
    padding: 0;
  }
}

.qr--image {
  text-align: center;
}

#overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  opacity: 0.8;
  background: #000;
}

.location-disabled-msg {
  position: absolute;
  width: 100%;
  height: 4vh;
  z-index: 2;
  color: #000;
  font-size: 14px;
  text-align: center;
  line-height: 4vh;
  background: var(--v-accent-base);
}

.forgot-password-link {
  margin-top: -5px;
  margin-bottom: 10px;
  cursor: pointer;
}

select {
  display: inline-block;
  color: black;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  padding: 0px 12px;
  width: 160px;
  height: 36px;
  margin: 0;
  border-color: #000;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1.5px solid;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-position: right 8px center;
}

select:active {
  outline: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%230E3F6D' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
}
</style>
